import { Component, Input } from '@angular/core';

import {
  PUBLIC_ABSENCE_STATUS
} from './vacation-api.constants';

@Component({
  selector: 'app-vacation-presence-badge',
  templateUrl: './vacation-presence-badge.component.html',
  styleUrls: ['./vacation-presence-badge.component.css']
})
export class VacationPresenceBadgeComponent {

  @Input() status: string;

  public readonly statuses = PUBLIC_ABSENCE_STATUS;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/vacation/vacation-presence-badge.component.ts